import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
import tokenHeader from '../token-header';
// const API_URL = 'https://localhost:9090 /api/all/ ';


const getPayment = 'pembayaran';
const getDetailOutstanding = 'pembayaran-oustanding/';
const exportData = 'pembayaran-export';
const getInvoice = 'pembayaran/detail/';
const getPengajuanRefund = 'pengajuan-refund'
const putPengajuanRefund = 'pengajuan-refund'
class PaymentService {
    
    putPengajuanRefund(formData) {
        return axios.put(
            API_URL + putPengajuanRefund,
            formData,
            {
                headers: authHeader()
            });
    }

    getData(currentPage, pageSize, tipe, filter, periode, id,kategori_pelatihan) {
        return axios.get(
            API_URL + getPayment + '?pageNo='+currentPage+'&pageSize='+pageSize+'&tipe='+tipe+'&filter='+filter+'&periode='+periode+'&id='+id +'&kategori_pelatihan='+kategori_pelatihan,
            {
                headers: authHeader()
            });
    }
    getPengajuanRefund(
        currentPage, 
        pageSize, 
        layanan, 
        tipe, 
        filter, 
        periode, 
        id
    ) {
        return axios.get(
            API_URL + getPengajuanRefund ,
            {
                params : {
                    pageNo : currentPage, 
                    pageSize : pageSize, 
                    layanan : layanan, 
                    tipe : tipe, 
                    filter : filter, 
                    periode : periode, 
                    id : id
                },
                headers: authHeader()
            });
    }

    getDetailOutstanding(idUser) {
        return axios.get(
            API_URL + getDetailOutstanding + idUser,{
                headers: authHeader()
        });
    }


    getInvoice(id_invoice) {
        return axios.get(
            API_URL + getInvoice + id_invoice,
            {
                headers: authHeader()
            });
    }

    download(tipe, periode, id, kategori_pelatihan) {
        return axios.get(
            API_URL + exportData + '?tipe_pembayaran=' + tipe + '&periode=' + periode + '&id=' + id + '&kategori_pelatihan=' + kategori_pelatihan,
            {
                headers: authHeader(),
                responseType: 'blob'
            });
    }

}

export default new PaymentService();